(() => {
  const carouselSelector = '[data-ocase-card-carousel]';
  const imageSelector = '[data-ocase-card-carousel-image]';
  const readyAttribute = 'data-ocase-card-carousel-ready';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function activate(images, index) {
    images.forEach((image, imageIndex) => {
      image.classList.toggle('is-active', imageIndex === index);
    });
  }

  function initCarousel(carousel) {
    if (carousel.hasAttribute(readyAttribute)) return;

    const images = Array.from(carousel.querySelectorAll(imageSelector));
    if (!images.length) return;

    carousel.setAttribute(readyAttribute, 'true');
    let index = Math.max(0, images.findIndex((image) => image.classList.contains('is-active')));
    activate(images, index);

    if (images.length < 2 || reducedMotion.matches) return;

    const interval = Number(carousel.dataset.interval) || 3600;
    let timer = null;

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (timer) return;
      timer = window.setInterval(() => {
        if (!carousel.isConnected) {
          stop();
          return;
        }

        index = (index + 1) % images.length;
        activate(images, index);
      }, interval);
    };

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);

    start();
  }

  function init(root = document) {
    root.querySelectorAll(carouselSelector).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
